export const LOCAL_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export default function useTimeZone() {
  return LOCAL_TIMEZONE;
}
